import slide1 from "./../styles/images/slide1.png";
import slide2 from "./../styles/images/slide2.png";
import slide3 from "./../styles/images/slide3.png";
import slide4 from "./../styles/images/slide4.png";
import slide5 from "./../styles/images/slide5.png";
import slide6 from "./../styles/images/slide6.png";
import slide7 from "./../styles/images/slide7.png";
import slide8 from "./../styles/images/slide8.png";
import slide9 from "./../styles/images/slide9.png";
import slide10 from "./../styles/images/slide10.png";
import slide11 from "./../styles/images/slide11.png";
import slide12 from "./../styles/images/slide12.png";
import slide13 from "./../styles/images/slide13.png";
import slide14 from "./../styles/images/slide14.png";
import slide15 from "./../styles/images/slide15.png";
import slide16 from "./../styles/images/slide16.png";
import slide17 from "./../styles/images/slide17.png";
import slide18 from "./../styles/images/slide18.png";
import slide19 from "./../styles/images/slide19.png";
import slide20 from "./../styles/images/slide20.png";

const projects = [
  {
    title: "Проект Avto-Sphere",
    img: slide1,
    skills: "",
    link: "https://www.avto-sphere.ru",
  },
  {
    title: "Проект GreatWallZap",
    img: slide2,
    skills: "",
    link: "https://www.greatwallzap.ru",
  },
  {
    title: "Проект Моего Сайта нулевых",
    img: slide3,
    skills: "",
    link: "https://www.aharenkov.ru",
  },
  {
    title: "Идем в Кино / Диплом Нетологии",
    img: slide4,
    skills: "",
    link: "https://pevec1.github.io/js-cp-diploma-edited/index.html",
  },
  {
    title: "Просто Верстка",
    img: slide5,
    skills: "",
    link: "",
  },
  {
    title: "Биржа / курсовая Нетологии",
    img: slide6,
    skills: "",
    link: "",
  },
    {
    title: "Игра",
    img: slide16,
    skills: "",
    link: "https://pevec1.github.io/js1-diplom/",
  },
  {
    title: "Мировые часы",
    img: slide17,
    skills: "проект на react.js",
    link: "https://axawatches.netlify.app/",
  },
  {
    title: "Calendar",
    img: slide18,
    skills: "",
    link: "https://axacalend.netlify.app/",
  },
  {
    title: "Zadachi",
    img: slide19,
    skills: "",
    link: "https://zadachi.good-cms.ru/",
  },
  {
    title: "To card, To list",
    img: slide20,
    skills: "проект на react.js",
    link: "https://pevec1.github.io/layouts/",
  },
  {
    title: "Project 7 CRUD",
    img: slide7,
    skills: "проект на react.js",
    link: "https://aharenkon.github.io/crud/",
  },
  {
    title: "Project 8",
    img: slide8,
    skills: "",
    link: "",
  },
  {
    title: "Project 9",
    img: slide9,
    skills: "",
    link: "",
  },
  {
    title: "Магазин Good-cms",
    img: slide10,
    skills: "",
    link: "",
  },
  {
    title: "Admin Goos-cms",
    img: slide11,
    skills: "",
    link: "",
  },
  {
    title: "Вариант 2 Good-cms",
    img: slide12,
    skills: "",
    link: "",
  },
  {
    title: "Project 13",
    img: slide13,
    skills: "",
    link: "",
  },
  {
    title: "Проект Dmitri Demidov",
    img: slide14,
    skills: "",
    link: "",
  },
  {
    title: "Wordpress",
    img: slide15,
    skills: "",
    link: "",
  },

];

export { projects };
